import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const xsdTemplateAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'xsdTemplateAPI',
    endpoints: (builder) => ({

        addXsdTemplate: builder.mutation({
            query: (data) => ({
                url: `/XsdTemplate/AddXsdTemplate`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateXsdTemplate: builder.mutation({
            query: (data) => ({
                url: `/XsdTemplate/UpdateXsdTemplate`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateXsdTemplateToggle: builder.mutation({
            query: (data) => ({
                url: `/XsdTemplate/UpdateXsdTemplateToggle`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getXsdTemplateList: builder.mutation({
            query: (data) => ({
                url: `/XsdTemplate/GetXsdTemplate`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getXmlSchemaByXMLReportTemplateId: builder.query({
            query: (Id) => ({
                url: `/XsdTemplate/GetXmlSchemaByXMLReportTemplateId?XMLReportTemplateId=${Id}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        addXMLTemplateSchema: builder.mutation({
            query: (data) => ({
                url: `/XsdTemplate/AddXMLSchema`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
         updateXmlTemplateSchema: builder.mutation({
            query: (data) => ({
                url: `/XsdTemplate/AddXMLSchema`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteXmlTemplateSchema: builder.mutation({
            query: (data) => ({
                url: `/XsdTemplate/DeleteXmlSchema?XMLReportTemplateId=${data.XMLReportTemplateId}&XMLSchemaID=${data.XMLSchemaID}`,
                method: `Delete`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        generateXmlSchemaFieldsForXSDTemplate: builder.query({
            query: (Id) => ({
                url: `/XsdTemplate/GenerateXmlSchemaFieldsForXSDTemplate?XMLReportTemplateId=${Id}`,
                method: `POST`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getXmlSchemaReport: builder.query({
            query: (Id) => ({
                url: `/XsdTemplate/GetXmlSchemaFields?XMLReportTemplateId=${Id}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

     })
});

export const { 
    useAddXsdTemplateMutation, 
    useUpdateXsdTemplateMutation,
    useUpdateXsdTemplateToggleMutation, 
    useGetXsdTemplateListMutation,
    useLazyGetXmlSchemaByXMLReportTemplateIdQuery,
    useAddXMLTemplateSchemaMutation,
    useUpdateXmlTemplateSchemaMutation,
    useDeleteXmlTemplateSchemaMutation,
    useLazyGenerateXmlSchemaFieldsForXSDTemplateQuery,
    useLazyGetXmlSchemaReportQuery
     } = xsdTemplateAPI;

export default xsdTemplateAPI;